const debugLog = (...args) => { if (window.__ARMORE_DEBUG__) console.log(...args); };

document.addEventListener("DOMContentLoaded", () => {
    // Initialize product image cards
    initializeProductCards()

    // Listen for any dynamically added product cards
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.addedNodes.length) {
                initializeProductCards()
            }
        })
    })

    // Start observing the document body for changes
    observer.observe(document.body, { childList: true, subtree: true });
})

function initializeProductCards() {
    

    // Find all product cards
    const productCards = document.querySelectorAll(".product-card-midevv-bs-nr-cs-midevv-ukcraftd-repl-best-seller-sec-2")
    

    productCards.forEach((card) => {
        // Skip already initialized cards
        if (card.dataset.initialized === "true") {
            
            return
        }

        // Custom ATC logic removed to fully defer to theme.js native quick-add flow.
        // This prevents any conflicting event bindings and ensures the native state machine owns the slideup and cart submission.

        // Sync state from native Quick Add button to Custom ATC button
        const capsBtn = card.querySelector('.caps');
        const customAtcBtn = card.querySelector('.add-btn-midevv-bs-nr-cs-midevv-ukcraftd-repl-best-seller-sec-2[data-button-quick-add-mobile]');


        if (capsBtn && customAtcBtn) {
            const classObserver = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.attributeName === 'class') {
                        if (capsBtn.classList.contains('is-loading')) {
                            customAtcBtn.classList.add('is-loading');
                        } else {
                            customAtcBtn.classList.remove('is-loading');
                        }

                        if (capsBtn.classList.contains('is-added')) {
                            customAtcBtn.classList.add('is-added');
                        } else {
                            customAtcBtn.classList.remove('is-added');
                        }
                    }
                });
            });

            classObserver.observe(capsBtn, { attributes: true, attributeFilter: ['class'] });
        }

        // Handle Swatch Hover and Click
        const swatches = card.querySelectorAll('.swatch-view-item');
        
        swatches.forEach(swatch => {
            swatch.addEventListener('mouseenter', () => {
                const variantId = swatch.getAttribute('option-value-id');
                updateImagesForVariant(card, variantId, true);
            });
            
            swatch.addEventListener('mouseleave', () => {
                const selectedVariantId = getSelectedVariantId(card);
                if (selectedVariantId) {
                    updateImagesForVariant(card, selectedVariantId, false);
                }
            });
            
            swatch.addEventListener('click', (e) => {
                e.preventDefault();
                const parent = swatch.closest('.swatch-view');
                parent.querySelectorAll('.swatch-view-item').forEach(el => {
                    el.classList.remove('is-active');
                    el.classList.remove('active');
                    el.setAttribute('aria-checked', 'false');
                });
                swatch.classList.add('is-active');
                swatch.classList.add('active');
                swatch.setAttribute('aria-checked', 'true');

                const labelText = swatch.getAttribute('orig-value');
                const labelContainer = swatch.closest('fieldset').querySelector('.midevv-selected-value');
                if (labelContainer) labelContainer.textContent = labelText;

                const variantId = swatch.getAttribute('option-value-id');
                updateImagesForVariant(card, variantId, false);
                syncSlideup(card, variantId);
            });
        });

        // Listen for slideup form changes to sync back to main swatch
        card.addEventListener('change', (e) => {
            if (e.target.matches('form[data-form-quick-add] input[data-single-option-selector]')) {
                setTimeout(() => {
                    const form = e.target.closest('form');
                    const idInput = form.querySelector('input[name="id"]');
                    if (idInput && idInput.value) {
                        syncMainSwatch(card, idInput.value);
                    }
                }, 50);
            }
        });

        handleSwatchImageLoading(card);

        card.dataset.initialized = "true"
        debugLog("Card initialized successfully")
    })
}

function handleSwatchImageLoading(card) {
    const container = card.querySelector('.selector-wrapper__scrollbar');
    if (!container) return;

    const images = container.querySelectorAll('img');

    if (images.length === 0) {
        container.classList.remove('is-loading');
        container.classList.add('is-ready');
        return;
    }

    let loadedCount = 0;

    const markReady = () => {
        container.classList.remove('is-loading');
        container.classList.add('is-ready');
    };

    images.forEach(img => {
        if (img.complete) {
            loadedCount++;
        } else {
            img.addEventListener('load', () => {
                loadedCount++;
                if (loadedCount === images.length) markReady();
            });

            img.addEventListener('error', () => {
                loadedCount++;
                if (loadedCount === images.length) markReady();
            });
        }
    });

    if (loadedCount === images.length) {
        markReady();
    }
}

function getSelectedVariantId(card) {
    const activeSwatch = card.querySelector('.swatch-view-item.is-active') || card.querySelector('.swatch-view-item[aria-checked="true"]');
    if (activeSwatch) {
        return activeSwatch.getAttribute('option-value-id');
    }
    
    // Fallback to first available or initial variant if none selected
    const productId = card.dataset.productId;
    const variantsDataElement = document.getElementById(`product-variants-${productId}`);
    if (variantsDataElement) {
        try {
            const variantsData = JSON.parse(variantsDataElement.textContent);
            const available = variantsData.variants.find(v => v.available);
            return available ? available.id : variantsData.variants[0].id;
        } catch (e) {}
    }
    return null;
}

function updateImagesForVariant(card, variantId, isPreview) {
    if (!variantId) return;
    const productId = card.dataset.productId;
    const variantsDataElement = document.getElementById(`product-variants-${productId}`);
    if (!variantsDataElement) return;

    try {
        const variantsData = JSON.parse(variantsDataElement.textContent);
        const variant = variantsData.variants.find(v => v.id == variantId);
        
        if (variant) {
            const primaryImg = card.querySelector('.primary-image-midevv');
            const secondaryImg = card.querySelector('.secondary-image-midevv');
            
            if (primaryImg && variant.featured_image) {
                // To avoid flickering, only update if src is different
                const newSrc = variant.featured_image;
                if (!primaryImg.src.includes(newSrc)) {
                    primaryImg.srcset = '';
                    primaryImg.src = newSrc;
                }
            }
            if (secondaryImg) {
                if (variant.secondary_image) {
                    const newSecSrc = variant.secondary_image;
                    if (!secondaryImg.src.includes(newSecSrc)) {
                        secondaryImg.srcset = '';
                        secondaryImg.src = newSecSrc;
                    }
                    secondaryImg.style.display = '';
                } else {
                    secondaryImg.style.display = 'none';
                }
            }
        }
    } catch (e) {
        console.error("Error updating images:", e);
    }
}

function syncSlideup(card, variantId) {
    const form = card.querySelector('form[data-form-quick-add]');
    if (!form) return;
    
    const productId = card.dataset.productId;
    const variantsDataElement = document.getElementById(`product-variants-${productId}`);
    if (!variantsDataElement) return;

    try {
        const variantsData = JSON.parse(variantsDataElement.textContent);
        const variant = variantsData.variants.find(v => v.id == variantId);
        
        if (variant) {
            // Update hidden ID input
            const idInput = form.querySelector('[name="id"]');
            if (idInput) {
                idInput.value = variantId;
                // Dispatch change event so theme.js knows it changed
                idInput.dispatchEvent(new Event('change', { bubbles: true }));
            }

            // Update radio buttons silently
            variant.options.forEach((optValue, index) => {
                const radio = form.querySelector(`input[type="radio"][data-index="option${index + 1}"][value="${optValue.replace(/"/g, '\\"')}"]`);
                if (radio && !radio.checked) {
                    radio.checked = true;
                }
            });
        }
    } catch (e) {
        console.error("Error syncing slideup:", e);
    }
}

function syncMainSwatch(card, variantId) {
    const targetSwatch = card.querySelector(`.swatch-view-item[option-value-id="${variantId}"]`);
    if (targetSwatch && !targetSwatch.classList.contains('is-active')) {
        const parent = targetSwatch.closest('.swatch-view');
        parent.querySelectorAll('.swatch-view-item').forEach(el => {
            el.classList.remove('is-active');
            el.classList.remove('active');
            el.setAttribute('aria-checked', 'false');
        });
        targetSwatch.classList.add('is-active');
        targetSwatch.classList.add('active');
        targetSwatch.setAttribute('aria-checked', 'true');

        const labelText = targetSwatch.getAttribute('orig-value');
        const labelContainer = targetSwatch.closest('fieldset').querySelector('.midevv-selected-value');
        if (labelContainer) labelContainer.textContent = labelText;

        updateImagesForVariant(card, variantId, false);
    }
}

function findVariantId(productId, optionPosition, optionValue) {
    // Get the product variants data from the JSON script
    const variantsDataElement = document.getElementById(`product-variants-${productId}`)
    if (!variantsDataElement) {
        console.error("No variants data element found for product ID:", productId)
        return null
    }

    try {
        const variantsData = JSON.parse(variantsDataElement.textContent)
        debugLog("Parsed variants data:", variantsData)

        // Find the variant that matches the selected option
        for (const variant of variantsData.variants) {
            if (variant.options[optionPosition - 1] === optionValue && variant.available) {
                debugLog("Found matching variant:", variant.id)
                return variant.id
            }
        }

        // If no match found, return the first available variant
        for (const variant of variantsData.variants) {
            if (variant.available) {
                debugLog("Using first available variant:", variant.id)
                return variant.id
            }
        }
    } catch (error) {
        console.error("Error parsing variants data:", error)
    }

    // Fallback to the default variant ID from the form
    const form = document.getElementById(`product-form-${productId}`)
    if (form) {
        const idInput = form.querySelector('input[name="id"]')
        if (idInput) {
            debugLog("Using fallback variant ID:", idInput.value)
            return idInput.value
        }
    }

    console.error("Could not find any variant ID")
    return null
}

function addToCart(productId) {
    const form = document.getElementById(`product-form-${productId}`)
    if (!form) {
        console.error("Form not found for product ID:", productId)
        return
    }

    debugLog("Adding to cart with form:", form)

    // Use Shopify AJAX API to add to cart
    fetch((window.Shopify?.routes?.root || window.theme?.routes?.root || '/') + 'cart/add.js', {
        method: "POST",
        credentials: "same-origin",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "X-Requested-With": "XMLHttpRequest",
        },
        body: new URLSearchParams(new FormData(form)),
    })
        .then((response) => {
            debugLog("Cart response status:", response.status)
            return response.json()
        })
        .then((data) => {
            debugLog("Cart response data:", data)
            // Success - update cart count and show notification
            if (typeof window.updateCartCount === "function") {
                window.updateCartCount()
            }

            // Show success message
            showToast("success", "added!")
        })
        .catch((error) => {
            console.error("Error adding to cart:", error)

            // Show error message
            showToast("error", "Could not add to cart. Please try again.")
        })
}

// Toast notification function
function showToast(type, message) {
    // Create toast element
    const toast = document.createElement("div")
    toast.className = `best-sellers-toast-midevv-bs-nr-cs-midevv-ukcraftd-repl-best-seller-sec-2 ${type}`
    toast.textContent = message

    // Add to document
    document.body.appendChild(toast)

    // Remove after delay
    setTimeout(() => {
        toast.classList.add("hide")
        setTimeout(() => {
            document.body.removeChild(toast)
        }, 300)
    }, 3000)
}

// Layout Switcher Functionality
document.addEventListener("DOMContentLoaded", () => {
    initializeLayoutSwitcher()
})

function initializeLayoutSwitcher() {
    debugLog("Initializing layout switcher")

    // Get layout switcher elements
    const layoutInputs = document.querySelectorAll('.js-grid-prd-switch-layout-item[name="mobile_layout"]')
    if (!layoutInputs.length) {
        debugLog("No layout switcher inputs found")
        return
    }

    // Apply saved layout preference if exists
    const savedLayout = localStorage.getItem("preferred_mobile_layout")
    if (savedLayout) {
        debugLog("Found saved layout preference:", savedLayout)
        applyLayoutPreference(savedLayout)

        // Check the corresponding radio button
        layoutInputs.forEach((input) => {
            if (input.value === savedLayout) {
                input.checked = true
            }
        })
    }

    // Add event listeners to layout switcher inputs
    layoutInputs.forEach((input) => {
        input.addEventListener("change", function () {
            const selectedLayout = this.value
            debugLog("Layout changed to:", selectedLayout)

            // Save preference to localStorage
            localStorage.setItem("preferred_mobile_layout", selectedLayout)

            // Apply the layout
            applyLayoutPreference(selectedLayout)
        })
    })
}

function applyLayoutPreference(layout) {
    debugLog("Applying layout preference:", layout)

    // Get the product grid container
    const productGrid = document.querySelector(".collection-product-grid")
    if (!productGrid) {
        debugLog("Product grid not found")
        return
    }

    // Update the grid style based on the selected layout
    if (layout === "1") {
        debugLog("Setting 1-column layout")
        productGrid.style.setProperty("--mobile-layout-size", "1")
    } else if (layout === "2") {
        debugLog("Setting 2-column layout")
        productGrid.style.setProperty("--mobile-layout-size", "2")
    }

    // Force a small reflow to ensure the layout updates
    productGrid.style.display = "none"
    setTimeout(() => {
        productGrid.style.display = ""
    }, 10)
}

